/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { useState } from "react";

import styled from "styled-components";

import { FileBlock } from "src/classes/block/block-types";

interface Props {
  block: FileBlock;
  disableMouse: boolean;
}

export function VideoWidget({ block, disableMouse }: Props) {
  const [isHovering, setIsHovering] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const showTitle = isHovering || !isPlaying;

  return (
    <VideoWidgetWrapper style={{ pointerEvents: disableMouse ? "none" : "auto" }}>
      {showTitle && (
        <div style={{ position: "absolute", top: "5px", left: "7px", paddingRight: "7px" }}>
          <VideoTitle>{block.fileDisplayName}</VideoTitle>
        </div>
      )}
      <video
        controls={isHovering}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        title={block.snapshot.originalFilename!}
      >
        <source src={block.fileURL} />
      </video>
    </VideoWidgetWrapper>
  );
}

const VideoWidgetWrapper = styled.div`
  position: relative;
  background-color: #f5f5f5;
  height: 100%;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  video {
    max-height: 100%;
    width: 100%;
  }
`;

const VideoTitle = styled.div`
  color: white;
  font-size: 18px;
  font-family: "IBM Plex Mono", sans-serif;
  background-color: black;
  padding-left: 5px;
  padding-right: 5px;
  user-select: text;
  pointer-events: all;
`;
